import type { CourseStatus } from '@openclassrooms/sdk-web';

import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

export type UserCourseLearningOutcomesParams = {
  userId: number;
  courseId: number;
  queryParams?: {
    status?: CourseStatus;
  };
};

const { useGet: useUserCourseLearningOutcomes } = getCRUDHooks({
  entityName: 'useUserCourseLearningOutcomes',
  get: ({ userId, courseId, queryParams = {} }: UserCourseLearningOutcomesParams) =>
    clientApi
      .getOCClient()
      .helpers.learningActivity.courses.getLearningOutcomes(userId, courseId, queryParams),
});

export {
  // eslint-disable-next-line import/prefer-default-export
  useUserCourseLearningOutcomes,
};
